import React, { useEffect, useState,useRef } from "react";
import { Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import swal from 'sweetalert';
import FilterBox from "components/FilterBox/FilterBox";
import InputField from "components/UI/Input/InputField";
import useValidator from '../../hooks/useValidator';
import { FetchAPI } from "api/fetch";
import { PostAPI } from "api/post";

const SupportModal = ({ rowData, columns, setRowData, setColumns, modalParams, showModal, setShowModal, filterFormValues, filterConfig, setHasError, setFilterFormValues, dynamicParameters, setDynamicParameters,  isLoader, setIsLoader, totalRecords, setTotalRecords, mapConfig, showGrid,convertToFormData }) => {
    const fileInputRef = useRef(null);
    const [showFilter, setShowFilter] = useState(false);
    const [page, setpage] = useState(1);
    const [filterPayload, setFilterPayload] = useState(null);
    const [selectedValue, setSelectedValue] = useState(null);
    const [formValues, setFormValues] = useState([]);
    const [disableButton, setDisableButton] = useState(false);
    const [validator, showValidationMessage] = useValidator();

    const options = {
        hideSizePerPage: true,
        hidePageListOnlyOnePage: true,
        sizePerPage: 10,
        page: page,
        totalSize: totalRecords
    }

    const converToArray = (formFields) => {
        const formElementsArray = [];
        for (let key in formFields) {
            formElementsArray.push({
                id: key,
                config: formFields[key]
            });
        }
        setFormValues(formElementsArray);
    }

    const closeModal = () => {
        setShowModal(!showModal)
    };

    const handleToggleFilter = () => {
        setShowFilter(!showFilter);
        const getURL = filterConfig.endpoint
        if(showFilter){
            getGridData(getURL)
        }
    }

    const updateDropdown = async (endpoint, payload, method) => {
        let response;
        const updateOrderForm = {
            ...mapConfig.formValues
        }
        if (method === "GET") {
            const paramsConverted = new URLSearchParams(payload);
            const getURL = `${endpoint}?${paramsConverted.toString()}`
            const getData = await FetchAPI(getURL);
            response = await getData.json(getData);
        } else {
            response = await PostAPI(endpoint, payload);
        }
        for (let identifier in updateOrderForm) {
            for (let dropdownKey in response.data) {
                if (dropdownKey === "material") {
                    updateOrderForm["oldEAN"].value = null;
                    updateOrderForm["old_used_qty"].value = "";
                    updateOrderForm["old_pending_qty"].value = "";
                    updateOrderForm["oldEAN"].elementConfig.options = response.data[dropdownKey];
                }
                if(dropdownKey === 'LOT'){
                    updateOrderForm["oldLOT"].value = null
                    updateOrderForm["oldLOT"].elementConfig.options = response.data[dropdownKey];
                }
                if(dropdownKey === 'Batch'){
                    updateOrderForm["oldBatch"].value = null
                    updateOrderForm["oldBatch"].elementConfig.options = response.data[dropdownKey];
                }
                if (response?.data?.data?.po_Info !== undefined) {
                    updateOrderForm["old_used_qty"].value = response.data.data.po_Info.used_qty
                    updateOrderForm["old_pending_qty"].value = response.data.data.po_Info.pending_qty
                }
                if (identifier === dropdownKey) {
                    updateOrderForm[identifier].elementConfig.options = response.data[dropdownKey];
                }
            }
        }
        converToArray(updateOrderForm);
    }

    const inputModalChangedHandler = (event, inputIdentifier) => {
        const inputTypes = ["text", "textarea","select"]
        const updateOrderForm = {
            ...mapConfig.formValues
        }
        if (inputTypes.includes(updateOrderForm[inputIdentifier].elementType)) {
            updateOrderForm[inputIdentifier].value = event.target.value;
        } else if (updateOrderForm[inputIdentifier].elementType === 'file') {
            updateOrderForm[inputIdentifier].value = event.target.files[0];
        } else if (updateOrderForm[inputIdentifier].elementType === 'selectshowsearch') {
            updateOrderForm[inputIdentifier].value = event
            if (updateOrderForm[inputIdentifier].update.required && event?.value) {
                let payload = { ...dynamicParameters, po_number: event.value };
                const islotBatchUpdateMapping = mapConfig.moduleFlag === 'lotmapping'
                if (islotBatchUpdateMapping && updateOrderForm["oldPO"].value?.value) {
                    payload = convertToFormData(payload)
                }
                if (!islotBatchUpdateMapping && updateOrderForm["oldPO"].value?.value && updateOrderForm["oldEAN"].value?.value) {
                    payload = { ...payload, oldPO: updateOrderForm["oldPO"].value.value, oldEAN: updateOrderForm["oldEAN"].value.value }
                    payload = convertToFormData(payload)
                }
                updateDropdown(updateOrderForm[inputIdentifier].update.endPoint, payload, updateOrderForm[inputIdentifier].update.method)
            }
        } else if (updateOrderForm[inputIdentifier].elementType === 'checkbox') {
            const isChecked = event.target.checked;
            updateOrderForm[inputIdentifier].value = inputIdentifier === 'status'? Number(isChecked) : isChecked;
            if(Object.hasOwn(updateOrderForm, 'file')){
            updateOrderForm["file"].elementConfig.disabled = !isChecked;
            updateOrderForm["file"].validate.required = isChecked;
            if(!isChecked){
                fileInputRef.current.value = null;
                updateOrderForm["file"].value = null;
            }
            }
            if (mapConfig.moduleFlag === 'lotmapping') {
                if (inputIdentifier === 'old_lot') {
                    const isChecked = event.target.checked;
                    updateOrderForm[inputIdentifier].value = isChecked;
                    if (Object.hasOwn(updateOrderForm, 'oldLOT')) {
                        updateOrderForm['oldLOT'].elementConfig.readOnly = !isChecked;
                    }
                    if (Object.hasOwn(updateOrderForm, 'newLOT')) {
                        updateOrderForm['newLOT'].elementConfig.readOnly = !isChecked;
                    }
                    setDynamicParameters(prevState => ({
                        ...prevState,
                        type: mapConfig.moduleFlag
                    }));
                }
        
                if (inputIdentifier === 'old_batch') {
                    const isChecked = event.target.checked;
                    updateOrderForm[inputIdentifier].value = isChecked;
                    if (Object.hasOwn(updateOrderForm, 'oldBatch')) {
                        updateOrderForm['oldBatch'].elementConfig.readOnly = !isChecked;
                    }
                    if (Object.hasOwn(updateOrderForm, 'newBatch')) {
                        updateOrderForm['newBatch'].elementConfig.readOnly = !isChecked;
                    }
                    setDynamicParameters((prevState => ({ ...prevState,
                        type: 'batchmapping' })))
                }
            }
        }
        converToArray(updateOrderForm);
    }

    const getGridData = async (getURL, totalParams, clearFlag) => {
        let paramsConverted;
        let endpoint;
        if(totalParams !== undefined){
            paramsConverted = new URLSearchParams(totalParams);
            endpoint = (`${getURL}?${paramsConverted.toString()}`);
        }else{
            endpoint = getURL;
        };
        setIsLoader(true);
        const response = await FetchAPI(endpoint);
        if (response.status === 200) {
            const responseJson = await response.json();
            if(responseJson?.data?.Status === 409){
                swal({icon: "warning",text: responseJson.data.Message});
                setIsLoader(false);
                return;
            };
            if (responseJson.data.Location) {
                window.location.href = responseJson.data.Location;
                setIsLoader(false);
                return;
            }
            setRowData(responseJson.data.data);
            setColumns(responseJson.data.columns);
            setTotalRecords(responseJson.data.recordsTotal);
            setIsLoader(false);
            if (clearFlag) {
                setShowFilter(false);
                setFilterFormValues(filterConfig.filterFormValues);
            }
        } else {
            setIsLoader(false);
        }
    }

    const getSearchFormData = (data,isMap) => {
        let searchFormData = {};
        for (let formElementIdentifier in data) {
            if (data[formElementIdentifier].elementType === 'multiselect') {
                if ((data[formElementIdentifier].value)) {
                    let arrayConvert = [];
                    data[formElementIdentifier].value.map(function (fValue, indexId) {
                        arrayConvert[indexId] = fValue.value;
                    });
                    searchFormData[formElementIdentifier] = arrayConvert;
                }
                else
                    searchFormData[formElementIdentifier] = null;
            }
            else if (data[formElementIdentifier].elementType === 'selectshowsearch') {
                if(data[formElementIdentifier].value){
                    if(isMap){
                        searchFormData[formElementIdentifier] = data[formElementIdentifier].value.value;
                    }else {
                        searchFormData[formElementIdentifier] = data[formElementIdentifier]?.value?.label
                    }
                }
            }
            else {
                searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
                if (mapConfig.moduleFlag === 'lotmapping') {
                    if (data['old_lot']?.value === true) {
                        delete searchFormData['newBatch'];
                        delete searchFormData['old_batch'];
                        delete searchFormData['oldBatch'];
                    }

                    if (data['old_batch']?.value === true) {
                        delete searchFormData['newLOT'];
                        delete searchFormData['old_lot'];
                        delete searchFormData['oldLOT'];
                    }
                }
            }
        }
        return searchFormData
    }

    const handlePageChange = async (page, sizePerPage) => {
        let startFrom = 0;
        let cpage = 0
        let totalParams;
        let getURL = filterConfig.saveEndpoint;
        let searchFormData = getSearchFormData(filterPayload)
        totalParams = { ...totalParams, ...dynamicParameters, role_id: 1, ...searchFormData }
        if (page == 1) {
            startFrom = 0;
            totalParams.start_from = startFrom;
        } else {
            cpage = page - 1;
            startFrom = cpage * sizePerPage;
            totalParams.start_from = startFrom;
        }
        getGridData(getURL, totalParams)
    }

    const handleTableChange = (event, { page, sizePerPage }) => {
        try {
            if (event == 'search') {
                return;
            }
            setpage(page);
            handlePageChange(page, sizePerPage);
            setSelectedValue(page);
        } catch (e) {
            setHasError({
                error: true,
                message: e
            })
        }
    }

    const handleClearFilter = async () => {
        const getURL = filterConfig.saveEndpoint;
        let start_from = 0;
        let totalParams = { ...dynamicParameters, start_from: start_from };
        getGridData(getURL, totalParams, true);
    }

    const searchTableData = async (data) => {
        setFilterPayload(data);
        const getURL = filterConfig.saveEndpoint;
        let searchFormData = getSearchFormData(data)
        searchFormData = { ...searchFormData, ...dynamicParameters, start_from: 0, filterSearch: true, role_id: 1}
        getGridData(getURL, searchFormData);
    }

    const handleFilterExport = async (data) => {
        setFilterPayload(data);
        const getURL = filterConfig.filterExportApi;
        let searchFormData = getSearchFormData(data)
        searchFormData = { ...searchFormData, ...dynamicParameters }
        getGridData(getURL, searchFormData)
    }

    const handleSubmitClick = async (moduleFlag) => {
        const radioParams = ["giftBox", "masterCarton"];
        let searchFormData = getSearchFormData(mapConfig.formValues,true)
        if (validator.allValid()) {
            for (let i in searchFormData) {
                if (radioParams.includes(i)) {
                    if (searchFormData[i] !== null) {
                        searchFormData.type = searchFormData[i].split("_").join(" ");
                    }
                    delete searchFormData[i];
                }
            }
            if (moduleFlag === "unbindMapping") {
                if(searchFormData.iot){
                    const splitIOTs = searchFormData.iot.split(",");
                    const regex = /^[A-Z]{4}\d{7}$/;
                    for(let element of splitIOTs){
                        if(regex.test(element) === false){
                            swal({
                                icon: "warning",
                                title: "Input must be 11 digit alphanumeric / comma separated values."
                            })
                            return;
                        }
                    }
                }
            }
            setDisableButton(true);
            const payloadObj = {
                 ...dynamicParameters, 
                 ...searchFormData,
                 ...(moduleFlag === "updateVendorQty") ? { vendorQtyUpdate: "1" } : {}
                 }
            const payload = (moduleFlag === "unbindMapping") ? payloadObj : convertToFormData(payloadObj);
            const response = await PostAPI(mapConfig.saveEndpoint, payload)

            if (response.status === 200) {
                const status = response?.data?.data?.status;
                const statusCodes = [1, 0, 409];
                status === 1 ? (() => { setDisableButton(true); closeModal(); })() : setDisableButton(false);
                if (statusCodes.includes(status)) {
                    swal({
                        icon: status === 1 ? "success" : "warning",
                        title: status === 1 ? "Success" : "Oops...!",
                        text: response?.data?.data?.message
                    })
                } else {
                    swal({
                        icon: "warning",
                        text: "Oops... something went wrong!"
                    })
                }

            } else {
                swal({
                    icon: "error",
                    text: "Oops... something went wrong!"
                })
            }
        } else {
            showValidationMessage(true)
        }
    }

    useEffect(() => {
        converToArray(mapConfig.formValues)
    }, [mapConfig])

    return (
        <Modal show={showModal} onHide={closeModal} dialogClassName={modalParams.modalWidth} backdrop="static" keyboard={false}>
            <Modal.Header closeButton className="modal-close-button">
                <Modal.Title>
                    <div className='font-weight-bold' style={{ color: 'white' }}>
                        <strong> {modalParams.modalTitle}</strong>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                {(showGrid && filterConfig.filter) && <div className="support-filter" ><button onClick={handleToggleFilter} className="primary-button" >Filter</button></div>}
                {(showGrid && showFilter) &&
                    <FilterBox
                        key="FilterBox"
                        title={"support"}
                        setformValues={setFilterFormValues}
                        formValue={filterFormValues}
                        isFilterLoader={isLoader}
                        filteredExport2={() => { }}
                        exportFilterButton={filterConfig.filterExport}
                        dropDownApi={filterConfig.dropDownApi}
                        filterConfig={filterConfig}
                        searchClick={searchTableData}
                        setHasError={setHasError}
                        clearClick={handleClearFilter}
                        filteredExport={handleFilterExport}
                        dropdownMethod={filterConfig.dropdownMethod}
                    />
                }
                {showGrid && (rowData?.length > 0 && columns?.length > 0 ?
                    <BootstrapTable
                        remote
                        striped
                        hover
                        condensed
                        bordered={false}
                        data={rowData}
                        columns={columns}
                        keyField="id"
                        noDataIndication={"No Data"}
                        wrapperClasses="table-responsive overflow-class"
                        headerClasses="grid-header"
                        onTableChange={handleTableChange}
                        pagination={paginationFactory({
                            ...options,
                            page: Number(selectedValue),
                        })}
                    />
                    :
                    <div className="no-data" >No Data </div>)
                }
                {(!showGrid && formValues?.length > 0) && (
                    <div className="form-container">
                        {formValues.map(formElement => (
                            <div className="form-field " >
                                <InputField
                                    key={formElement.id}
                                    elementType={formElement.config.elementType}
                                    elementConfig={formElement.config.elementConfig}
                                    value={formElement.config.value}
                                    labelName={formElement.config.label}
                                    id={formElement.config.id}
                                    isValidate={formElement.config.validate}
                                    changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                    validater={validator}
                                    readonly={formElement.config.elementConfig.readonly}
                                    setHasError={setHasError}
                                    show={formElement.config.show}
                                    checked={formElement.config.checked}
                                    name={formElement.config.name}
                                    ref={fileInputRef}
                                    title="Support"
                                />
                            </div>
                        ))}
                    </div>
                )}

            </Modal.Body>
            <Modal.Footer>
                <button className="info-button" onClick={closeModal}  >Close</button>
                {(!showGrid && formValues?.length > 0) && (
                    <button className={disableButton ? "button-disabled" : "primary-button"} disabled={disableButton} onClick={() => handleSubmitClick(mapConfig.moduleFlag)} >Submit</button>
                )}
            </Modal.Footer>
        </Modal>
    )
}

export default SupportModal;